<style scoped>
  .text-center{text-align: center}
  input{background-color:#ffea9f;border: none;text-align: center}
</style>
<template>
  <div>
    <p style="font-size:24pt;" class="text-center">
      法 律 事 务 委 托 合 同
    </p>
    <p style="font-size: 14pt;text-align: center">（行政复议、行政诉讼、国家赔偿）</p>
    <div style="padding:20px"></div>
    <!--<p style="text-align:right;font-size:14pt">合同编号：琼云联律行字[<input style="width:2em" v-model="text[0]"></input>]第<input style="width:5em" v-model="text[1]"></input>号</p>-->
    <div style="padding:20px"></div>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">聘请方（甲方）：<input style="width:5em" v-model="text[2]"></input></p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">受聘方（乙方）：{{$store.state.userInfo.companyName}}</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">根据中华人民共和国《合同法》、《律师法》及其他有关法律的规定，甲方委托乙方律师作为委托代理人。双方按照诚实信用原则，经协商一致，立此合同，共同遵守。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">第一条 委托代理事项：乙方接受甲方委托，指派律师在以下案件中担任甲方的委托代理人：</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">（一）各方当事人名称或者姓名：</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">原告（申请人、申诉人、上诉人）：<input style="width:5em" v-model="text[3]"></input></p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">被告（被申请人、被申诉人、被上诉人）：<input style="width:5em" v-model="text[4]"></input></p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">第三人：<input style="width:5em" v-model="text[5]"></input></p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">（二）案由、案号：<input style="width:10em" v-model="text[6]"></input></p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">（三）受理机关：<input style="width:10em" v-model="text[7]"></input></p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">（四）受理阶段：<input style="width:10em" v-model="text[8]"></input></p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">（五）争议标的额（申请赔偿额）：<input style="width:10em" v-model="text[9]"></input></p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">第二条 委托代理权限：以甲方出具的授权委托书载明的为准。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">第三条 甲方的权利和义务</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">（一）甲方应当真实、客观、全面地向乙方介绍案情，提供与委托代理事项有关的证据、文件及其他相关材料；如与本案有关的情况和事实发生变化，应及时告知乙方律师。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">（二）甲方应当积极主动地配合乙方律师的工作，对乙方律师提出的要求应当明确具体、合法合理；不得要求乙方律师进行违法或者有违律师执业规范的活动。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">（三）甲方应当依约按时、足额地向乙方支付律师服务费和差旅费等。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">（四）甲方有权要求乙方及时更换在服务过程中工作不负责任、或不适合办理甲方委托的法律事务的乙方律师，但甲方提出此要求的理由应充分、合理。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">（五）甲方有权要求乙方复印与委托的法律事务相关的材料，但法律法规和律师执业规范规定应当保密的材料除外。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">第四条 乙方的权利和义务</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">（一）乙方指派<input style="width:5em" v-model="text[10]"></input>律师为委托代理人。该指派律师因故不能履行职务时，由乙方另行指派律师，经甲方确认并重新出具授权委托书后，继续完成本合同约定的委托事务。如需开庭的，另行指派的律师应有合理的时间熟悉案情，保证开庭的质量。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">（二）乙方律师应当依法依理、勤勉尽责地完成委托代理事务，并应甲方合理要求通报工作进程，向甲方进行法律风险提示，切实维护甲方的合法权益。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">（三）乙方律师在诉讼或仲裁案件开庭后，应及时向法庭或仲裁庭提交书面代理意见。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">（四）乙方律师对获知的甲方商业秘密或个人隐私负有保密责任，非因法律规定或者甲方同意，不得向任何第三方披露。但以下内容除外：</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">1、刑事犯罪证据；</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">2、可以公开查阅或取得的信息和资料；</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">3、为履行本合同所约定的服务必须进行的工作。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">（五）如甲方隐瞒有关委托事务的真实情况或要求乙方律师从事违反法律或律师执业规范的活动，乙方有权拒绝。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">第五条 本合同生效后，甲乙双方均可依法解除合同，因解除合同给对方造成损失的，除不可归责于解除合同一方的事由外，应当赔偿对方因此而发生的损失，赔偿金额以乙方实际收到的律师服务费为限。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">第六条 费用的确定与支付</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">（一）收费依据：国家和海南省律师服务收费的现行有效规定。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">（二）律师服务费：双方协商确定采用如下第<input style="width:1em" v-model="text[11]"></input>种方式。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">计件方式：甲方应向乙方支付律师服务费人民币<input style="width:5em" v-model="text[12]"></input>元。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">付费时间为下列第<input style="width:1em" v-model="text[13]"></input>种。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">（1）在本合同签订生效之日起<input style="width:1em" v-model="text[14]"></input>日内一次性支付；</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">2、其他约定：<input style="width:10em" v-model="text[15]"></input></p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">2、按标的额比例收费方式：甲方参照《海南省律师服务收费行业指导意见》规定的比例向乙方支付律师服务费人民币<input style="width:1em" v-model="text[16]"></input>元。 付费时间为下列第<input style="width:1em" v-model="text[17]"></input>种。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">（1）在本合同签订生效之日起<input style="width:1em" v-model="text[18]"></input>日内一次性支付；</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">（2）其他约定：<input style="width:10em" v-model="text[19]"></input></p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">3、计时方式：甲方应按每小时人民币<input style="width:2em" v-model="text[20]"></input>元向乙方支付律师服务费。计时清单由双方根据案件的情况另行确定。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">付费时间为：<input style="width:5em" v-model="text[21]">。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">4、其他收费方式：<input style="width:10em" v-model="text[22]"></input></p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">无论选择上述何种方式计付律师服务费，甲方均应以现金或转账方式直接向乙方支付并索取有效发票；向乙方律师个人或其他个人支付的，乙方均不予认可。本合同落款处的乙方账户为收费账户。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">乙方收到甲方支付的律师服务费，不论是一次性支付还是分期支付，均应在收到款项后及时开具有效发票，最迟不超过15个工作日。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">（三）乙方律师在完成甲方的法律事务过程中发生的差旅费、诉讼费（仲裁费）、保全费、鉴定费、评估费、公证费、公告费、查档费等费用，由甲方另行支付。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">（四）甲方逾期支付律师服务费的，从逾期之日起，按应付金额每日万分之六支付违约金。经乙方催告后仍未支付律师服务费的，乙方有权解除合同，但应当通知甲方。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">第七条 本合同生效后，因调解、和解、撤诉等原因引起甲方在本合同中委托乙方律师代理的案件结案或终结诉讼（仲裁）的，均视为乙方已全面履行本合同约定的义务，甲方应当依约支付律师服务费及已发生的差旅费等。双方另有约定的除外。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">第八条 因乙方律师的过错行为导致甲方蒙受损失，乙方通过其投保的执业保险向甲方承担过错赔偿责任，赔偿金额以乙方投保的执业保险金额为限。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">第九条 甲方确认下列通讯方式及联系人是乙方办理本合同委托事务向甲方履行通知义务的通讯方式及联系人：</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun"><input style="width:10em" v-model="text[23]"></input></p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">如果甲方变更通讯方式或联系人,需提前七日书面通知乙方。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">第九条 因履行本合同发生争议，双方应友好协商；协商不成的，可选择下列第<input style="width:1em" v-model="text[24]"></input>种方式解决：</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">1、提交海南仲裁委员会仲裁；</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">2、向人民法院提起诉讼。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">第十条 本合同一式<input style="width:2em" v-model="text[25]"></input>份，双方各执<input style="width:2em" v-model="text[26]"></input>份，自双方签字盖章之日起效。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">第十一条 甲方承诺：已认真审阅本合同所有格式条款并完全了解其详尽内容；本合同所有条款均属双方平等且完全协商一致而达成。</p>
    <p style="text-indent:2em;font-size:14pt;font-family:Simsun">第十二条 未尽审宜，双方可在本条另行特别约定：<input style="width:35em" v-model="text[27]"></input></p>
    <div style="padding:20px"></div>
    <Row style="font-size:14pt;font-family:SimSun">
      <Col span="12">
        <Row>
          <Col span="5" style="text-align: right">甲方：</Col>
          <Col span="19"><input style="width:10em" v-model="text[28]"></input></Col>
        </Row>
        <div style="padding:5px"></div>
        <Row>
          <Col span="5" style="text-align: right">法定代表人：</Col>
          <Col span="19"><input style="width:10em" v-model="text[29]"></Col>
        </Row>
        <div style="padding:5px"></div>
        <Row>
          <Col span="5" style="text-align: right">地址：</Col>
          <Col span="19"><input style="width:10em" v-model="text[30]"></Col>
        </Row>
        <Row>
          <Col span="5" style="text-align: right">电话：</Col>
          <Col span="19"><input style="width:10em" v-model="text[31]"></Col>
        </Row>
        <Row>
          <Col span="5" style="text-align: right">开户行：</Col>
          <Col span="19"><input style="width:10em" v-model="text[32]"></Col>
        </Row>
        <Row>
          <Col span="5" style="text-align: right">账号：</Col>
          <Col span="19"><input style="width:10em" v-model="text[33]"></Col>
        </Row>
      </Col>
      <Col span="12">
        <Row>
          <Col span="5" style="text-align: right">乙方：</Col>
          <Col span="19"><input style="width:10em" v-model="text[34]"></Col>
        </Row>
        <div style="padding:5px"></div>
        <Row>
          <Col span="5" style="text-align: right">法定代表人：</Col>
          <Col span="19"><input style="width:10em" v-model="text[35]"></Col>
        </Row>
        <div style="padding:5px"></div>
        <Row>
          <Col span="5" style="text-align: right">地址：</Col>
          <Col span="19"><input style="width:10em" v-model="text[36]"></Col>
        </Row>
        <Row>
          <Col span="5" style="text-align: right">电话：</Col>
          <Col span="19"><input style="width:10em" v-model="text[37]"></Col>
        </Row>
        <Row>
          <Col span="5" style="text-align: right">开户行：</Col>
          <Col span="19"><input style="width:10em" v-model="text[38]"></Col>
        </Row>
        <Row>
          <Col span="5" style="text-align: right">账号：</Col>
          <Col span="19"><input style="width:10em" v-model="text[39]"></Col>
        </Row>
      </Col>
    </Row>
    <p style="text-align: right;font-size:14pt;font-family:Simsun">签约日期：<input style="width:2em" v-model="text[40]">年<input style="width:2em" v-model="text[41]">月<input style="width:2em" v-model="text[42]">日</p>
    <p style="text-align: center;font-size:14pt;font-family:Simsun"><input style="width:100%" v-model="text[43]"></input></p>
    <div style="padding:10px"></div>
    <div style="text-align: center">
      <Button type="primary" style="width:200px" @click="saveContract()">保 存 合 同</Button>
      <Button type="success" style="width:200px;margin-left:50px" @click="saveContract(true)">发 起 合 同 盖 章 审 批</Button>
    </div>
  </div>
</template>
<script>
  export default {
    name: "administration",//行政
    data:function () {
      return{
        text:[],
        client:[],
        opposed:[],
        userList:[],
        caseInfo:{},
      }
    },
    mounted:function () {
      this.getContractContent()
    },
    methods:{
      approvalContract:function(){
        var _this = this
        _this.saveContract(function () {
          _this.send({
            headers:'V/FileCreate',
            data:{
              CaseId:_this.$route.query.caseId
            },
            success:function (res) {
              if(!_this.isEmpty(res)){
                var src = res.substr(('/home/wwwroot/'+SYSCONFIG.server.default.host+'/public/').length+1,res.length)
              }else{
                _this.$Notice.errpr({
                  title:'系统消息',
                  desc:'网络繁忙！'
                })
              }
              var approvalData = [
                {"name":"approvalInput","content":{"title":"案号","text":_this.caseInfo.case_num,"must":false,"allowSubmission":true}},
                {"name":"approvalFile","content":{"title":"文件","fileName":"合同文件","filesSrc":src,"seal":"1","must":false,"allowSubmission":true}}
              ]
              var modeId
              if(window.sessionStorage.groupId==1){
                modeId=1
              }else{
                modeId=35
              }
              _this.send({
                headers:'L/AddApproval',
                data:{
                  ExcessAssessors:_this.caseInfo.case_executor_id,
                  ApprovalModeId:modeId,
                  CaseId:_this.$route.query.caseId,
                  ApprovalContent:approvalData,
                },
                success:function () {
                  _this.$Notice.success({
                    title:'系统消息',
                    desc:'发起审批成功！'
                  })
                  _this.$router.push({name:'projectList'})
                }
              })
            }
          })
        })
      },
      //获取当事人列表
      getLitigationList:function(){
        var _this = this
        _this.send({
          headers:'E/LitigatsList',
          data:{
            CaseId:_this.$route.query.caseId,
          },
          success:function (res) {
            _this.client = []
            _this.opposed = []
            for(var index in res){
              if(res[index].LitigationStatusId==1){
                _this.client.push({
                  id:res[index].LitigantId,
                  name:res[index].LitigantName,
                  litigation:res[index].LawsuitId,
                  identity :res[index].LitigantTypeId,
                  IDCardCode:res[index].LitigantIdCard,
                })
              }
              if(res[index].LitigationStatusId==2){
                _this.opposed.push({
                  id:res[index].LitigantId,
                  name:res[index].LitigantName,
                  litigation:res[index].LawsuitId,
                  identity :res[index].LitigantTypeId,
                  IDCardCode:res[index].LitigantIdCard,
                })
              }
            }
            _this.getUserList()
          }
        })
      },
      //获取用户数据
      getUserList:function(searchText){
        var _this = this
        _this.userList = []
        _this.send({
          headers:'C/LawList',
          data:{
            key:searchText||'',
          },
          success:function (res) {
            var tempObj = []
            for(var index in res){
              tempObj.push({id:res[index].UserId,name:res[index].UserName,icon:res[index].UserImg})
            }
            _this.userList = tempObj
            _this.selectUserList = tempObj
            _this.projectRegister()
          }
        })
      },
      //获取案件数据
      projectRegister: function () {
        var _this = this
        _this.send({
          headers: "E/ShowSingleCase",
          data: {
            CaseId: _this.$route.query.caseId
          },
          success: function (res) {
            _this.caseInfo = res
            var clientArr = []//委托方
            var plaintiffArr = []//原告
            var accusedArr = []//被告
            var lawArr = []//律师
            for(var index in _this.client){
              clientArr.push(_this.client[index].name)
              if(_this.client[index].litigation==1){
                plaintiffArr.push(_this.client[index].name)
              }
            }
            for(var index in _this.opposed){
              if(_this.opposed[index].litigation==1){
                accusedArr.push(_this.opposed[index].name)
              }
            }
            for(var index in res.case_executor_id.split(',')){
              if(_this.userList.find((secItem)=>{return secItem.id==res.case_executor_id.split(',')[index]})){
                lawArr.push(_this.userList.find((secItem)=>{return secItem.id==res.case_executor_id.split(',')[index]}).name)
              }
            }

            /*
            approval_id: null
case_acceptance_id: null
case_acceptance_text: null
case_action_detail_id: null
case_action_id: null
case_action_info: "111"
case_action_second_id: null
case_action_type_id: null
case_charge_id: "5"
case_class_id: 1
case_conflict_id: 1
case_create_time: "2019-08-21"
case_creater_id: 1
case_end_time: null
case_executor_id: "10"
case_focus: null
case_from_id: "14"
case_id: 2
case_info: null
case_linkman: "222"
case_linkman_tel: "333"
case_member_id: "5"
case_num: "(2019）琼云联民诉字第2号"
case_pay_count: "666"
case_pay_ratio: null
case_pay_way: null
case_situation: "bbb"
case_source_id: 4
case_stage: "888"
case_subject_matter: "444"
case_title: "111222111"
case_type_id: 1
case_update_time: null
case_updater_id: null
executor_suggestion_id: null
group_suggestion_id: null
lead_suggestion_id: null
litigants_id: "3,4"
main_appeal: null
manage_user: null
message_user: null
other_case_info: null
our_litigant_msg: null
purview_group: null
purview_user: null
that_litigant_msg: null
            CaseActionTypeId:_this.$route.query.id,//业务范围ID
            CaseActionId:_this.content.causeTypeSelected,//案由ID
            CaseActionSecondId:_this.content.modelTypeSelected,//细分模板ID
            CaseActionDetailId:_this.content.modelSelected,//模板ID
            // ----
            CaseCreateTime:_this.content.createDate,//收案日期
            // Procedures:_this.content.procedures,//办案程序
            // ----
            CaseTitle:_this.content.name,//项目标题
            CaseNum:'',//案件类型ID 刑事、民事、行政、商经ID
            CaseTypeId:_this.$route.query.id,//业务范围ID
            CaseClassId:_this.content.projectClassSelected,//案件类型ID 刑事、民事、行政、商经ID
            CaseSubjectMatter:_this.content.casetAmount,//争议标的额
            CasePayCount:_this.content.projectAmount,//收费金额
            CasePayWay:_this.content.payType,//结算方式ID
            CaseChargeId:_this.content.payType,//结算方式ID
            CaseStage:_this.content.caseStage,//案件阶段
            CaseAcceptanceId:_this.content.receivingUnit,//案件受理机关ID -- *
            LitigationArr:tempArr,//当事人
              CaseSituation:_this.content.caseDetails,//简要案情
              CaseFromId:_this.content.source.toString(),//案源律师
              CaseExecutorId:_this.content.manager.toString(),//承办律师
              CaseMemberId:_this.content.otherUser.toString(),//其他律师
              CaseActionInfo:_this.content.cause,//案由
              CaseLinkman:_this.content.contactName,//联系人
              CaseLinkmanTel:_this.content.contactMobile,//联系电话
              CaseSource:_this.content.caseSource,//案件来源
              CaseConflictId:_this.content.conflictRules,//利益冲突规则
              CaseClassId:_this.content.caseType,//案件类型ID
             */
            _this.text[2]==null||_this.text[2]==''?_this.$set(_this.text,'2',clientArr.toString()):''
            _this.text[3]==null||_this.text[3]==''?_this.$set(_this.text,'3',plaintiffArr.toString()):''
            _this.text[4]==null||_this.text[4]==''?_this.$set(_this.text,'4',accusedArr.toString()):''
            _this.text[6]==null||_this.text[6]==''?_this.$set(_this.text,'6',res.case_action_info):''
            _this.text[7]==null||_this.text[7]==''?_this.$set(_this.text,'7',res.case_acceptance_text):''
            _this.text[8]==null||_this.text[8]==''?_this.$set(_this.text,'8',res.case_stage):''
            _this.text[9]==null||_this.text[9]==''?_this.$set(_this.text,'9',res.case_subject_matter):''
            _this.text[10]==null||_this.text[10]==''?_this.$set(_this.text,'10',lawArr.toString()):''
            _this.text[23]==null||_this.text[23]==''?_this.$set(_this.text,'23',res.case_linkman+':'+res.case_linkman_tel):''
            _this.text[28]==null||_this.text[28]==''?_this.$set(_this.text,'28',clientArr.toString()):''
            _this.text[40]==null||_this.text[40]==''?_this.$set(_this.text,'40',new Date().getFullYear()):''
            _this.text[41]==null||_this.text[41]==''?_this.$set(_this.text,'41',new Date().getMonth()+1):''
            _this.text[42]==null||_this.text[42]==''?_this.$set(_this.text,'42',new Date().getDate()):''
            _this.text[34]=_this.isEmpty(_this.text[34])?_this.$store.state.userInfo.companyName:_this.text[34]
            if(_this.$store.state.userInfo.companyName.indexOf('文昌')!=-1){
              _this.text[35]=_this.isEmpty(_this.text[35])?'魏道言':_this.text[35]
              _this.text[36]=_this.isEmpty(_this.text[36])?'海南省文昌市文城镇文建路49-77-1号五楼':_this.text[36]
              _this.text[37]=_this.isEmpty(_this.text[37])?'（0898）':_this.text[37]
              _this.text[38]=_this.isEmpty(_this.text[38])?'中国农业银行股份有限公司文昌文建支行':_this.text[38]
              _this.text[39]=_this.isEmpty(_this.text[39])?'21344001040002456':_this.text[39]
            }else{
              _this.text[35]=_this.isEmpty(_this.text[35])?'李晶瑜':_this.text[35]
              _this.text[36]=_this.isEmpty(_this.text[36])?'海口市美兰区和平大道20号鹏晖国际大厦第十层':_this.text[36]
              _this.text[37]=_this.isEmpty(_this.text[37])?'（0898）6860 2020':_this.text[37]
              _this.text[38]=_this.isEmpty(_this.text[38])?'招商银行股份有限公司海口分行':_this.text[38]
              _this.text[39]=_this.isEmpty(_this.text[39])?'898901287010666':_this.text[39]
            }
          }
        })
      },

      saveContract:function(callback){
        var _this = this
        _this.send({
          headers:'V/UpdateVisaFile',
          data:{
            CaseId:_this.$route.query.caseId,
            ContractFileContent:_this.text,
          },
          success:function (res) {
            // _this.$router.push({name:'projectSeal',query:{caseId:_this.$route.query.caseId,taskId:_this.$route.query.taskId}})
            _this.$Notice.success({
              title:'系统消息',
              desc:'保存成功！'
            })
            if(callback){
              callback()
            }
          }
        })
      },
      getContractContent:function () {
        var _this = this
        _this.send({
          headers:'V/VisaFile',
          data:{
            CaseId:_this.$route.query.caseId
          },
          success:function (res) {
            if(res.ContractFileContent){
              _this.$set(_this,'text',res.ContractFileContent)
            }else{
              _this.text.length=44
              for(var i=0;i<_this.text.length;i++){
                _this.text[i]=''
              }
              _this.$set(_this.text,'43','海南省法律服务监督投诉电话：（0898） 65919080、（0898） 66161293')
            }
            _this.getLitigationList()
          }
        })
      }
    }
  }
</script>